export const baseUrl = process.env.REACT_APP_BASE_URL
export const MAINTENANCE_MODE = process.env.REACT_APP_MAINTENANCE_MODE
// export const chartThreeMonthColors = ['#1977f2', '#ff8bc1', '#ffcd4e']
export const chartThreeMonthColors = [
  '#1977f2',
  '#ff8bc1',
  '#ffcd4e',
  '#34c759',
  '#ff453a',
  '#5e5ce6',
  '#ffa500',
  '#000000',
]
export const applicantSiteUrl = process.env.REACT_APP_APPLICANT_SITE_URL
export const referralEmail = process.env.REACT_APP_REFERRAL_EMAIL
export const inactivityTimer = process.env.REACT_APP_INACTIVITY_TIMER
